export {
  readClipboardImage,
  readClipboardText,
  type ClipboardImage,
} from '@wrongstack/runtime/clipboard';
